import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { BookingresultModalPage } from './bookingresult-modal.page';

const routes: Routes = [
  {
    path: '',
    component: BookingresultModalPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class BookingresultModalPageRoutingModule {}
